import React, { Component } from "react";
import { Segment } from "semantic-ui-react";
import SegmentMessage from "../forms/messages/SegmentMessage.jsx";

class ErrorBoundary extends Component {
  state = {
    hasError: false,
    error: null
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: error };
  }

  render() {
    // error return
    if (this.state.hasError) {
      const { error } = this.state;
      return (
        <Segment textAlign="left">
          <SegmentMessage
            title="React Error Boundary"
            message="Something Went Wrong"
            negative={true}
          />
          <details style={{ whiteSpace: "pre-wrap" }}>
            {error && error.toString()}
            <br />
            {error.stack}
          </details>
        </Segment>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
